import { useState } from 'react';
import { Grid, Text } from '@mantine/core';
import { ORBIT_DISABLED, ORBIT_GRAY } from '@/theme/colors';
import type { SubscriberInput } from '../../../../../../bots/src/handlers/update-insurance-coverage';
import { SubscriberFormValues } from './subscriber';
import { SubscriberForm } from './SubscriberForm';

interface SubscriberRowProps {
  label: string;
  display: string;
  muted: boolean;
  initial: SubscriberFormValues;
  /** Rejects if the write fails; the form stays open. */
  onSave: (input: SubscriberInput) => Promise<void>;
}

/** The Subscriber row: click the value to edit the policyholder in place, in the panel's 3/9 grid. */
export function SubscriberRow({ label, display, muted, initial, onSave }: SubscriberRowProps) {
  const [editing, setEditing] = useState(false);

  return (
    <Grid align="flex-start" style={{ width: '100%' }}>
      <Grid.Col span={3}>
        <Text style={{ fontSize: 13, lineHeight: '16px', color: ORBIT_GRAY }}>{label}</Text>
      </Grid.Col>
      <Grid.Col span={9}>
        {editing ? (
          <SubscriberForm
            initial={initial}
            onSave={async (input) => {
              await onSave(input);
              setEditing(false);
            }}
            onCancel={() => setEditing(false)}
          />
        ) : (
          <Text
            onClick={() => setEditing(true)}
            style={{
              cursor: 'pointer',
              fontSize: 14,
              lineHeight: '20px',
              color: muted ? ORBIT_DISABLED : 'var(--mantine-color-black)',
            }}
          >
            {display}
          </Text>
        )}
      </Grid.Col>
    </Grid>
  );
}
